var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.909,
    height: 28.69,
    viewBox: "0 0 25.909 28.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.008 1.038)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 11.947,
    y1: 6.889,
    transform: "translate(5.973 2.931)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.894,20.583V9.964a2.655,2.655,0,0,0-1.327-2.3l-9.292-5.31a2.655,2.655,0,0,0-2.655,0L4.327,7.667A2.655,2.655,0,0,0,3,9.964V20.583a2.655,2.655,0,0,0,1.327,2.3l9.292,5.31a2.655,2.655,0,0,0,2.655,0l9.292-5.31A2.655,2.655,0,0,0,26.894,20.583Z",
    transform: "translate(-3 -2.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.27,6.96l11.588,6.7,11.588-6.7",
    transform: "translate(-2.912 -0.379)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 13.38,
    transform: "translate(11.947 13.271)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.7411d9eca217cf63a065bf3220bd6543.svg";
export { ForwardRef as ReactComponent };